<!--==================================
=            PROGRESSBARS            =
===================================-->
<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Progressbar</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Determinate</div>

          <div slot="card-body">
            <div>
              <v-progress-linear v-model="valueDeterminate" color="deep-purple accent-4"></v-progress-linear>
              <br />
              <v-progress-linear v-model="valueDeterminate" color="pink"></v-progress-linear>
              <br />
              <v-progress-linear v-model="valueDeterminate" color="indigo darken-2"></v-progress-linear>
              <br />
              <v-progress-linear v-model="valueDeterminate" color="amber"></v-progress-linear>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Indeterminate</div>
          <div slot="card-body">
            <div>
              <v-progress-linear v-model="value" :buffer-value="bufferValue"></v-progress-linear>
              <br />
              <v-progress-linear v-model="value" :buffer-value="bufferValue" color="purple"></v-progress-linear>
              <br />
              <v-progress-linear v-model="value" :buffer-value="bufferValue" color="red lighten-2"></v-progress-linear>
              <br />
              <v-progress-linear v-model="value" :buffer-value="bufferValue" color="black"></v-progress-linear>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Buffer</div>
          <div slot="card-body">
            <div>
              <v-progress-linear
                v-model="value"
                :active="show"
                :indeterminate="query"
                :query="true"
              ></v-progress-linear>
            </div>
          </div>
        </base-card>
      </v-col>

      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Query Indeterminate and Determinate</div>
          <div slot="card-body">
            <div>
              <v-progress-linear
                background-color="pink lighten-3"
                color="pink lighten-1"
                value="15"
              ></v-progress-linear>
              <br />
              <v-progress-linear background-color="blue-grey" color="lime" value="30"></v-progress-linear>
              <br />
              <v-progress-linear background-color="success" color="error" value="45"></v-progress-linear>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PROGRESSBAR -->
      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Rounded</div>
          <div slot="card-body">
            <div>
              <v-progress-linear
                background-color="pink lighten-3"
                color="pink lighten-1"
                value="15"
              ></v-progress-linear>
              <br />
              <v-progress-linear background-color="blue-grey" color="lime" value="30"></v-progress-linear>
              <br />
              <v-progress-linear background-color="success" color="error" value="45"></v-progress-linear>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Stream</div>
          <div slot="card-body">
            <div>
              <v-progress-linear color="red lighten-2" buffer-value="0" stream></v-progress-linear>
              <br />
              <v-progress-linear color="teal" buffer-value="0" value="20" stream></v-progress-linear>
              <br />
              <v-progress-linear buffer-value="50" stream color="cyan"></v-progress-linear>
              <br />
              <v-progress-linear buffer-value="60" value="40" stream color="orange"></v-progress-linear>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Striped</div>
          <div slot="card-body">
            <div>
              <v-progress-linear color="light-blue" height="10" value="10" striped></v-progress-linear>
              <br />
              <v-progress-linear color="light-green darken-4" height="10" value="20" striped></v-progress-linear>
              <br />
              <v-progress-linear height="10" value="45" striped color="lime"></v-progress-linear>
              <br />
              <v-progress-linear value="60" height="10" striped color="deep-orange"></v-progress-linear>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Toolbar loader</div>
          <div slot="card-body">
            <v-card class="mx-auto mt-6" width="344">
              <v-system-bar>
                <div class="flex-grow-1"></div>
                <v-icon>mdi-square</v-icon>
                <v-icon>mdi-circle</v-icon>
                <v-icon>mdi-triangle</v-icon>
              </v-system-bar>

              <v-toolbar>
                <v-btn icon>
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>

                <v-toolbar-title>My Recipes</v-toolbar-title>

                <v-progress-linear
                  :active="loading"
                  :indeterminate="loading"
                  absolute
                  bottom
                  color="deep-purple accent-4"
                ></v-progress-linear>

                <div class="flex-grow-1"></div>

                <v-btn icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-toolbar>

              <v-container style="height: 282px;">
                <v-row class="fill-height" align="center" justify="center">
                  <v-scale-transition>
                    <div v-if="!loading" class="text-center">
                      <v-btn color="primary" @click="loading = true">Start loading</v-btn>
                    </div>
                  </v-scale-transition>
                </v-row>
              </v-container>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">File loader</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="344">
              <v-toolbar color="deep-purple accent-4" dark prominent>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>

                <v-toolbar-title>My Files</v-toolbar-title>

                <v-btn absolute bottom color="white" fab left light>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>

                <div class="flex-grow-1"></div>

                <v-btn icon>
                  <v-icon>mdi-share-variant</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-toolbar>

              <v-container style="height: 400px;">
                <v-row class="fill-height" align-content="center" justify="center">
                  <v-col class="subtitle-1 text-center" cols="12">Getting your files</v-col>
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- PROGRESSBAR -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Slots</div>
          <div slot="card-body">
            <div class="pa-5">
              <v-progress-linear v-model="power" color="amber" height="25" reactive></v-progress-linear>

              <br />

              <v-progress-linear v-model="skill" color="blue-grey" height="25" reactive>
                <template v-slot="{ value }">
                  <strong>{{ Math.ceil(value) }}%</strong>
                </template>
              </v-progress-linear>

              <br />

              <v-progress-linear v-model="knowledge" height="25" reactive>
                <strong>{{ Math.ceil(knowledge) }}%</strong>
              </v-progress-linear>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },

  data: () => ({
    skill: 20,
    knowledge: 33,
    power: 78
  })
};
</script>

<!--====  End of PROGRESSBARS  ====-->
